export const api = {
    queryDeviceWorkGroup: '/bms/device/queryDeviceWorkGroup.json', //查可燃气体设备组
    queryGasOperationList: '/bas/gasoperation/queryGasOperationList.json', //查询列表
}